import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  {
    path: 'app',
    loadChildren: () => import('./modules/home').then((m) => m.HOME_ROUTES),
  },
  {
    path: '404',
    loadChildren: () => import('./modules/error-page-not-found').then((m) => m.ERROR_PAGE_ROUTES),
  },
  {
    path: '',
    redirectTo: `app`,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
